import React, { useEffect, useMemo } from 'react';
import { DidomiSDK } from '@didomi/react';
import { syncProfileConsentFromDidomi } from '../../../util/analyticsConsent';
import { DIDOMI_THEME, getDidomiRuntimeConfig } from '../../../util/didomiConfig';

/**
 * Loads the Didomi Web SDK for profile microsites (OEK-2872).
 * Didomi apiKey is a code constant; notice/vendor settings from /v2/base or JSP bootstrap.
 */
const ProfileDidomiSdk = () => {
  const {
    apiKey,
    noticeId,
    privacyPolicyUrl,
    gdprAppliesGlobally,
    embedTcfStub,
    embedGppStub,
    country,
    region,
  } = getDidomiRuntimeConfig();

  const didomiConfig = useMemo(() => ({
    app: {
      privacyPolicyURL: privacyPolicyUrl,
    },
    theme: DIDOMI_THEME,
    ...(country ? {
      user: {
        country,
        ...(region ? { region } : {}),
      },
    } : {}),
  }), [country, privacyPolicyUrl, region]);

  useEffect(() => {
    const bind = (Didomi) => {
      if (!Didomi || Didomi.__oeProfileConsentObserverBound) {
        return;
      }
      Didomi.__oeProfileConsentObserverBound = true;
      if (typeof Didomi.on === 'function') {
        Didomi.on('consent.changed', syncProfileConsentFromDidomi);
      }
    };
    if (window.Didomi) {
      bind(window.Didomi);
    }
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push(bind);
  }, []);

  if (!apiKey || !noticeId) {
    return null;
  }

  return (
    <DidomiSDK
      apiKey={apiKey}
      noticeId={noticeId}
      config={didomiConfig}
      gdprAppliesGlobally={gdprAppliesGlobally}
      embedTCFStub={embedTcfStub}
      embedGPPStub={embedGppStub}
      country={country}
      region={region}
    />
  );
};

export default ProfileDidomiSdk;
